// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   ResultsGrid — product cards grid
   ============================================ */

.grb-widget--results {
  display: flex;
  flex-direction: column;
}

.grb-widget--results-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--grb-spacing-md);
  border-bottom: 1px solid var(--grb-color-border);
}

.grb-widget--results-count {
  font-size: var(--grb-font-size-sm);
  color: var(--grb-color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.grb-widget--results-grid {
  display: grid;
  grid-template-columns: repeat(var(--grb-grid-columns-desktop), 1fr);
  gap: var(--grb-grid-gap);
}

/* Tablet: 3 columns */
@media (max-width: 1024px) and (min-width: 769px) {
  .grb-widget--results-grid {
    grid-template-columns: repeat(var(--grb-grid-columns-tablet), 1fr);
  }
}

/* Mobile: 2 columns */
@media (max-width: 768px) {
  .grb-widget--results-grid {
    grid-template-columns: repeat(var(--grb-grid-columns-mobile), 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/results.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,gDAAgD;AAClD;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE;IACE,kEAAkE;EACpE;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,kEAAkE;EACpE;AACF","sourcesContent":["/* ============================================\n   ResultsGrid — product cards grid\n   ============================================ */\n\n.grb-widget--results {\n  display: flex;\n  flex-direction: column;\n}\n\n.grb-widget--results-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--grb-spacing-md);\n  border-bottom: 1px solid var(--grb-color-border);\n}\n\n.grb-widget--results-count {\n  font-size: var(--grb-font-size-sm);\n  color: var(--grb-color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.grb-widget--results-grid {\n  display: grid;\n  grid-template-columns: repeat(var(--grb-grid-columns-desktop), 1fr);\n  gap: var(--grb-grid-gap);\n}\n\n/* Tablet: 3 columns */\n@media (max-width: 1024px) and (min-width: 769px) {\n  .grb-widget--results-grid {\n    grid-template-columns: repeat(var(--grb-grid-columns-tablet), 1fr);\n  }\n}\n\n/* Mobile: 2 columns */\n@media (max-width: 768px) {\n  .grb-widget--results-grid {\n    grid-template-columns: repeat(var(--grb-grid-columns-mobile), 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
